import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getUserDetailsFromReducer } from "Store/reducers/Auth/AuthSlice";
import {
  faWhatsapp,
  faFacebook,
  faLinkedin,
  faRedditAlien,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCopy,
  faEnvelope,
  faShare,
} from "@fortawesome/free-solid-svg-icons";
import UploadProfilePic from "@/components/UploadProfilePic";

const ShareLinks = () => {
  const [copied, setCopied] = useState(false);
  const userDetails = useSelector(getUserDetailsFromReducer);

  if (!userDetails?.username) {
    return (
      <p>Profile not available to share. Please publish your profile first.</p>
    );
  }

  const shareUrl = `https://inprofile.co/${userDetails.username}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Check out my profile!",
          text: `Explore ${userDetails.username}'s profile on InProfile`,
          url: shareUrl,
        });
      } catch (error) {
        console.error("Error sharing", error);
      }
    } else {
      alert(
        "Native sharing is not supported on this browser. Please copy the link instead."
      );
    }
  };

  const shareSocialLinks = [
    {
      icon: faFacebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
      bg: "bg-blue-600",
    },
    {
      icon: faWhatsapp,
      url: `https://wa.me/?text=${shareUrl}`,
      bg: "bg-green-500",
    },
    {
      icon: faXTwitter,
      url: `https://twitter.com/intent/tweet?url=${shareUrl}`,
      bg: "bg-black",
    },
    {
      icon: faLinkedin,
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`,
      bg: "bg-blue-700",
    },
    {
      icon: faRedditAlien,
      url: `https://www.reddit.com/submit?url=${shareUrl}`,
      bg: "bg-orange-500",
    },
    {
      icon: faEnvelope,
      url: `mailto:?subject=Check this out!&body=${shareUrl}`,
      bg: "bg-gray-500",
    },
  ];

  return (
    <div className="space-y-4 p-4 m-2">
      <div className="bg-slate-950 p-10 rounded-2xl shadow-lg flex flex-col items-center w-106 m-3">
        <div className="w-28 h-28 rounded-xl overflow-hidden flex items-center justify-center">
          <UploadProfilePic
            S3Key={userDetails?.logo}
            alt="User Logo"
            className="w-full h-full object-contain  p-8"
          />
        </div>

        <h2 className="text-xl text-white font-bold mt-2">
          @{userDetails.username}
        </h2>
      </div>
      {/* Social Media Buttons */}
      <div className="flex gap-3  flex-wrap justify-center">
        <button
          onClick={handleNativeShare}
          className="w-12 h-12 mt-3 flex justify-center items-center rounded-full bg-gray-700"
        >
          <FontAwesomeIcon icon={faShare} className="text-white text-2xl " />
        </button>
        {shareSocialLinks.map(({ icon, url, bg }, index) => (
          <a
            key={index}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={`w-12 h-12 mt-3 flex justify-center items-center rounded-full ${bg}`}
          >
            {typeof icon === "object" ? (
              <FontAwesomeIcon icon={icon} className="text-white text-2xl" />
            ) : (
              React.createElement(icon, { className: "text-white text-xl" })
            )}
          </a>
        ))}
      </div>

      {/* Copy Link Section */}
      <div className="flex items-center bg-black p-3 rounded-lg gap-3">
        <button
          onClick={handleCopy}
          className="flex items-center gap-3 text-white"
        >
          <FontAwesomeIcon
            icon={copied ? faCheck : faCopy}
            className={`${copied ? "text-green-400 text-xl" : "text-xl"} `}
          />

          <span>{shareUrl}</span>
        </button>
        {copied && <span className="text-green-400 font-bold">Copied!</span>}
      </div>
    </div>
  );
};

export default ShareLinks;
